import { render, staticRenderFns } from "./home-common-title.vue?vue&type=template&id=6bf7a9a2&scoped=true&"
import script from "./home-common-title.vue?vue&type=script&lang=js&"
export * from "./home-common-title.vue?vue&type=script&lang=js&"
import style0 from "./home-common-title.vue?vue&type=style&index=0&id=6bf7a9a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf7a9a2",
  null
  
)

export default component.exports